import React from "react";
import { useDroppable } from "@dnd-kit/react";

export default function StopDropSlot({
  routeId,
  index,
  active,
}: {
  routeId: string;
  index: number;
  active: boolean;
}) {
  const { ref } = useDroppable({
    id: `stop-slot-${routeId}-${index}`,
    type: "stop-slot",
    accept: "stop",
    collisionPriority: 30,
    data: { routeId, index },
  });

  return (
    <li className="relative h-0 shrink-0 list-none">
      <div
        ref={ref}
        className="absolute inset-x-0 -top-2 h-4 bg-transparent"
        data-testid={`stop-slot-${routeId}-${index}`}
      >
        {active ? (
          <div
            role="status"
            className="pointer-events-none absolute inset-0 z-20 flex items-center"
          >
            <span
              aria-hidden
              className="h-2 w-2 shrink-0 rounded-full bg-sky-600"
            />
            <span aria-hidden className="h-0.5 flex-1 bg-sky-600" />
            <span className="shrink-0 rounded-full bg-sky-600 px-2 py-0.5 text-[10px] font-semibold leading-none text-white shadow-sm">
              Drop here
            </span>
            <span aria-hidden className="h-0.5 flex-1 bg-sky-600" />
            <span
              aria-hidden
              className="h-2 w-2 shrink-0 rounded-full bg-sky-600"
            />
          </div>
        ) : null}
      </div>
    </li>
  );
}
